export default {
    isFetching: false,
    slots: [],
    error: {
        status: '',
        statusText: '',
    },
}
